import { useEffect } from 'react'
import { AppSettings } from './appSettings'
import { usePartner } from './context/PartnerContext'

const baseUrl = import.meta.env.VITE_BASE_URL

export const BrandingSwitcher: React.FC = () => {
  const { currentPartner } = usePartner()

  useEffect(() => {
    switch (currentPartner?.partner) {
      case 'Jap':
        setJapBranding()
        break
      case 'Essox':
        setEssoxBranding()
        break
      default:
        setDefaultBranding()
        break
    }
  }, [currentPartner?.partner])

  return null
}

const setJapBranding = () => {
  if (AppSettings.enviroment !== 'production')
    setTitle(`JAP ${AppSettings.enviroment.toUpperCase()}`)
  else
    setTitle('JAP')

  const prefix = baseUrl + '/branding/jap'
  setManifest(prefix + '/manifest.json')
  setFavicon(prefix + '/favicons/favicon.ico')
  setFavicon(prefix + '/favicons/android-icon-192x192.png', 'icon', '192x192')
  setFavicon(prefix + '/favicons/android-icon-144x144.png', 'icon', '144x144')
  setFavicon(prefix + '/favicons/favicon-96x96.png', 'icon', '96x96')
  setFavicon(prefix + '/favicons/android-icon-72x72', 'icon', '72x72')
  setFavicon(prefix + '/favicons/favicon-32x32.png', 'icon', '32x32')
  setFavicon(prefix + '/favicons/favicon-16x16.png', 'icon', '16x16')
  setFavicon(prefix + '/favicons/apple-icon-180x180.png', 'apple-touch-icon', '180x180')
  setFavicon(prefix + '/favicons/apple-icon-167x167.png', 'apple-touch-icon', '167x167')
  setFavicon(prefix + '/favicons/apple-icon-152x152.png', 'apple-touch-icon', '152x152')
  setFavicon(prefix + '/favicons/apple-icon-144x144.png', 'apple-touch-icon', '144x144')
  setFavicon(prefix + '/favicons/apple-icon-120x120.png', 'apple-touch-icon', '120x120')
  setFavicon(prefix + '/favicons/apple-icon-80x80.png', 'apple-touch-icon', '80x80')
  setFavicon(prefix + '/favicons/apple-icon-76x76.png', 'apple-touch-icon', '76x76')
  setFavicon(prefix + '/favicons/apple-icon.png', 'apple-touch-icon')
}

const setEssoxBranding = () => {
  setTitle('Essox')

  const prefix = baseUrl + '/branding/essox'
  setManifest(prefix + '/manifest.json')
  setFavicon(prefix + '/favicons/favicon.ico')
  setFavicon(prefix + '/favicons/favicon-96x96.png', 'icon', '96x96')
  setFavicon(prefix + '/favicons/favicon-32x32.png', 'icon', '32x32')
  setFavicon(prefix + '/favicons/favicon-16x16.png', 'icon', '16x16')
  setFavicon(prefix + '/favicons/android-icon-192x192.png', 'icon', '192x192')
  setFavicon(prefix + '/favicons/android-icon-144x144.png', 'icon', '144x144')
  setFavicon(prefix + '/favicons/android-icon-72x72', 'icon', '72x72')
  setFavicon(prefix + '/favicons/apple-icon-180x180.png', 'apple-touch-icon', '180x180')
  setFavicon(prefix + '/favicons/apple-icon-152x152.png', 'apple-touch-icon', '152x152')
  setFavicon(prefix + '/favicons/apple-icon-144x144.png', 'apple-touch-icon', '144x144')
  setFavicon(prefix + '/favicons/apple-icon-120x120.png', 'apple-touch-icon', '120x120')
  setFavicon(prefix + '/favicons/apple-icon-114x114.png', 'apple-touch-icon', '114x114')
  setFavicon(prefix + '/favicons/apple-icon-76x76.png', 'apple-touch-icon', '76x76')
  setFavicon(prefix + '/favicons/apple-icon.png', 'apple-touch-icon')
}


const setDefaultBranding = () => {

}

const setFavicon = (url: string, rel: 'icon' | 'apple-touch-icon' = 'icon', sizes?: string) => {
  let selector = `link[rel*='${rel}']`
  if (sizes)
    selector += `[sizes='${sizes}']`
  const link: HTMLLinkElement | null = document.querySelector(selector)
  if (link) {
    link.href = url
  } else {
    const newLink = document.createElement('link')
    newLink.rel = rel
    newLink.href = url
    if (sizes)
      newLink.setAttribute('sizes', sizes)

    document.head.appendChild(newLink)
  }
}

const setTitle = (title: string) => {
  document.title = title
}

const setManifest = (url: string) => {
  const link: HTMLLinkElement | null = document.querySelector('link[rel="manifest"]')
  if (link) {
    link.href = url
  }
}
